module.exports = __webpack_public_path__ + "img/bg2.b7d2aab4.png";